import { PipeObject, Token } from '../types';
import { AddCssClassToBody } from '../../utils/add-css-class-body/add-css-class-body';

let tableClassAdded = false;
export const Table = () => {
  return ({ input, data, lex }: PipeObject) => {
    let obj: Token;
    let continuingTable = false;
    let tableSections: Array<any> = [];
    let tableCounter = 0;

    // replace the start->end with table html
    while ((obj = lex.next())) {
      if (obj.token === 'table') {
        if (!continuingTable) {
          continuingTable = true;
          tableSections[tableCounter] = {
            start: obj.begin,
            tableBuilder: {
              Columns: 0,
              Head: [],
              Alignment: [],
              Body: [],
            },
          };
        }

        const value = input.substring(obj.begin + 1, obj.end - 1);
        // first row, that will always be header
        // second row will be -- with alignments (:---, :---:, ---:)
        // every row after the first two will be the body
        if (tableSections[tableCounter]?.tableBuilder.Columns === 0) {
          // this is our first row, count how many columns
          const splitOnPipe = value.split('|');
          tableSections[tableCounter].tableBuilder.Columns = splitOnPipe.length;
          tableSections[
            tableCounter
          ].tableBuilder.Head = splitOnPipe.filter((x) => x.trim());
        } else if (
          tableSections[tableCounter].tableBuilder.Columns > 0 &&
          tableSections[tableCounter].tableBuilder.Alignment.length === 0
        ) {
          // we're in the second row, get alignments
          for (const iterator of value.split('|')) {
            const clean = iterator.trim();
            const firstChar = clean.charAt(0);
            const endChar = clean.charAt(clean.length - 1);
            if (firstChar === ':' && endChar === ':') {
              tableSections[tableCounter].tableBuilder.Alignment.push('center');
            } else if (endChar === ':') {
              tableSections[tableCounter].tableBuilder.Alignment.push('right');
            } else {
              tableSections[tableCounter].tableBuilder.Alignment.push('left');
            }
          }
        } else if (
          tableSections[tableCounter].tableBuilder.Columns > 0 &&
          tableSections[tableCounter].tableBuilder.Alignment.length > 0
        ) {
          // the rest of rows
          const splitOnPipe = value.split('|');
          tableSections[tableCounter].tableBuilder.Body.push(splitOnPipe);
        }
      } else {
        if (continuingTable) {
          continuingTable = false;
          tableSections[tableCounter] = {
            ...tableSections[tableCounter],
            end: obj.end,
          };

          tableCounter++;
        }
      }
    }

    let newInput = input;
    for (let index = 0; index < tableSections.length; index++) {
      const table = tableSections[index];
      // build the table
      let stringBuilder = '';
      if (
        table.tableBuilder.Columns > 0 &&
        table.tableBuilder.Head.length > 0 &&
        table.tableBuilder.Alignment.length > 0 &&
        table.tableBuilder.Body.length > 0
      ) {
        stringBuilder += '<table class="cvna-parser-table" width="100%">';

        // head
        stringBuilder += '<tr>';
        for (let index = 0; index < table.tableBuilder.Head.length; index++) {
          const head = table.tableBuilder.Head[index];
          const align = table.tableBuilder.Alignment[index];
          stringBuilder += `<th class="${align}">${head}</th>`;
        }
        stringBuilder += '</tr>';

        // body
        table.tableBuilder.Body.forEach((body) => {
          stringBuilder += '<tr>';
          for (let index = 0; index < body.length; index++) {
            const row = body[index];
            const align = table.tableBuilder.Alignment[index];
            stringBuilder += `<td class="${align}">${row}</td>`;
          }
          stringBuilder += '</tr>';
        });

        stringBuilder += '</table>';
      }

      if (stringBuilder) {
        newInput = newInput
          .replace(input.substring(table.start, table.end - 1), stringBuilder)
          .trim();
      }
    }

    if (!tableClassAdded) {
      tableClassAdded = AddCssClassToBody(`
      .cvna-parser-table td, .cvna-parser-table th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 8px;
      }
      .cvna-parser-table .right {
        text-align: right;
      }
      .cvna-parser-table .left {
        text-align: left;
      }
      .cvna-parser-table .center {
        text-align: center;
      }
      `);
    }

    return { input: newInput, data, lex };
  };
};
